import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useI18n } from "../../i18n/useI18n";
import styles from '../styles/users.module.scss';
import assignmentStyles from '../../assignments/styles/assignment.module.scss';
import { useGetAllRoles } from "../hooks/useGetAllRoles";
import { loadRoles } from "../slices/rolSlice";
import UIcon from "@/assets/uicons/UIcon";

interface HeaderProps {
  saveNewItem: () => void;
  title: string;
  buttonText: string;
}

export const Header = ({
  saveNewItem,
  title,
  buttonText,
}: HeaderProps) => {
  const { t } = useI18n();
  const dispatch = useDispatch();
  const { data: rolesData, isSuccess: isSuccessRoles } = useGetAllRoles();

  useEffect(() => {
    const getRols = async () => {
      if (isSuccessRoles && rolesData) {
        dispatch(loadRoles(rolesData));
      }
    };
    getRols();

    // Cleanup function
    return () => {
      dispatch(loadRoles({ success: false, message: "", data: [] }));
    };
  }, [rolesData, isSuccessRoles, dispatch]);

  return (
    <div className={styles["headerusers"]}>
      <h2 className={styles["headerusers__title"]}>
        {t(title)}
      </h2>
      <div className={assignmentStyles["header-assignment__divUserGroupDateAndSelect"]}>
        <button className={styles["headerusers__button"]} onClick={saveNewItem}>
          <UIcon name="editPencil" />
          {t(buttonText)}
        </button>
      </div>
    </div>
  );
};